/**
 * Top-level page wrapper for ZTNA Admin Dashboard (route: /admin/ztna).
 *
 * Permission check segue padrão usado em /admin/permissoes (useCan + Navigate).
 * Permissão necessária: `ztna:onboard:provision` (mesma do backend
 * `_require_ztna_admin` em ztna_onboarding/endpoints.py).
 */
import { Container } from '@mantine/core'
import { Navigate } from 'react-router-dom'
import { Dashboard } from '@/components/ZtnaAdmin'
import { useCan } from '@/store/auth'

export default function ZtnaAdmin() {
  const can = useCan()

  // admin:full bypass está embutido no useCan().
  if (!can('ztna:onboard', 'provision')) {
    return <Navigate to="/" replace />
  }

  return (
    <Container size="xl" py="md">
      <Dashboard />
    </Container>
  )
}
